// Module
var code = "<div class=\"mb-checkbox checkbox-success\"> <label> <% if(isChecked){ %> <input id=\"{{cid}}\" type=\"checkbox\" class=\"filled-in\" checked=\"checked\"/> <% } else { %> <input id=\"{{cid}}\" type=\"checkbox\" class=\"filled-in\"/> <% } %> <span>{{displayName}}</span> </label> </div> ";
// Exports
export default code;